<div class="mainFilterMobile" *ngIf="offersData?.length > 0">
  <div class="mainFilterMobile__sorting" (click)="openSorting()">
    <div class="sorting__icon">
      <svg-icon
        src="/resultpage/assets/icons/Sorting.svg"
        [svgStyle]="{ 'width.px': 25 }"
        aria-hidden="true"
      ></svg-icon>
    </div>
    <div>
      <p class="sorting__title">Sortieren</p>
      <p class="sorting__option">{{ sortingOption.name }}</p>
    </div>
  </div>
  <div class="mainFilterMobile__filter" (click)="openFilter()">
    <p class="filter__title">
      <span class="title__icon">
        <svg-icon
          src="/resultpage/assets/icons/Filter.svg"
          [svgStyle]="{ 'width.px': 25 }"
          aria-hidden="true"
        ></svg-icon>
      </span>
      Filtern
    </p>
  </div>
  <div class="mainFilter__overlay" *ngIf="filterOverlay"></div>
</div>
<div class="mainFilter" id="filter">
  <div class="mainFilter__title-wrapper">
    <h2 class="mainFilter__title">Kredite filtern</h2>
    <button
      class="mainFilter__skip-to-offers"
      (click)="skipToOffers()"
      aria-label="Springe zu den Kreditangeboten"
      type="button"
    >
      Filter überspringen
    </button>
  </div>
  <div class="mainFilter__content">
    <ng-container *ngFor="let option of filter; trackBy: trackByFilterOption">
      <ng-container *ngIf="option.data.length !== 0">
        <container-element [ngSwitch]="option.type">
          <section class="content__chart" *ngSwitchCase="'barplot'">
            <h3>{{ option.title }}</h3>
            <app-filter-barplot-range
              [rateData]="option"
              [key]="option.key"
              (rangeOutput)="postFilter($event, 'range')"
            >
            </app-filter-barplot-range>
          </section>
          <section *ngSwitchCase="'checkbox'">
            <div class="mainFilter__subtitle">
              <h3>{{ option.title }}</h3>
              <app-hint *ngIf="option.hint" [hintData]="option.hint"></app-hint>
            </div>
            <ng-container *ngFor="let checkbox of option.data; trackBy: trackByCheckboxOption">
              <app-checkbox
                [checkboxData]="checkbox"
                [key]="option.key"
                (checkboxOutput)="postFilter($event, 'checkbox')"
              ></app-checkbox>
            </ng-container>
          </section>
          <section *ngSwitchCase="'radio'">
            <div class="mainFilter__subtitle">
              <h3>{{ option.title }}</h3>
              <app-hint *ngIf="option.hint" [hintData]="option.hint"></app-hint>
            </div>
            <app-filter-radio-button
              *ngIf="option.key !== 'interestTypes'"
              [key]="option.key"
              [radioButtonData]="option.data"
              (radioOutput)="postFilter($event, 'radio')"
            ></app-filter-radio-button>
            <app-multiple-choice-radio-button
              *ngIf="option.key === 'interestTypes'"
              [options]="option.data"
              [key]="option.key"
              [radioButtonData]="option.interestTypesRadioData"
              (radioOutput)="postFilter($event, 'radio')"
            >
            </app-multiple-choice-radio-button>
          </section>
        </container-element>
      </ng-container>
    </ng-container>
    <button class="mainFilter__reset" (click)="postFilter($event, 'reset')">
      <p>Filter zurücksetzen</p>
    </button>
  </div>
  <div class="mainFilter__overlay" *ngIf="filterOverlay"></div>
</div>
